<template>
  <div>
    <div id="signbody">
      <div>
        <div class="SignIn-body">
          <div class="cover">
            <div class="logo">拱墅区卫监信息管理平台</div>
            <div class="loginmain">
              <div class="loginl"></div>
              <div class="loginr">
                <div class="accounttitle">登录</div>
                <el-form
                  :model="loginForm"
                  :rules="rules"
                  ref="loginForm"
                  label-width="0"
                  class="demo-ruleForm"
                >
                  <el-form-item prop="username">
                    <el-input
                      v-model="loginForm.username"
                      placeholder="请输入用户名"
                      class="usernameinput"
                    >
                      <i slot="prefix" style="display:flex">
                        <img src="../images/username.png" style="width:20px;height:20px" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      type="password"
                      v-model="loginForm.password"
                      placeholder="请输入密码"
                      class="passinput"
                    >
                      <i slot="prefix">
                        <i slot="prefix" style="display:flex">
                          <img src="../images/password.png" style="width:20px;height:20px" />
                        </i>
                      </i>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      type="primary"
                      :loading="loginLoading"
                      class="submitbtn"
                      @click="submitForm('loginForm')"
                    >登录</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <!-- <div class="bombtn">
              平台服务商：&nbsp;&nbsp;
              <a
                href="http://www.terabits.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >杭州钛比科技有限公司</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：&nbsp;&nbsp;0571-87755736
            </div> -->
            <div class="bombtns">浙ICP备16003817号-1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网站标识码：3610782</div>
            <div class="bombtns">
              <img />
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602007808"
                target="_blank"
                rel="noopener noreferrer"
              >浙公网安备33010602009975号</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login, currentUser } from "../axios/api.js";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };

    return {
      loginForm: {
        password: "",
        username: ""
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        username: [{ validator: validateName, trigger: "blur" }]
      },

      loginLoading: false,
      redirect: undefined
    };
  },
  methods: {
    submitForm() {
      console.log(this.loginForm.username);

      // this.$router.push("/unit");
      this.$refs.loginForm.validate(valid => {
        console.log(valid);
        if (valid) {
          login([this.loginForm.username, this.loginForm.password]).then(
            res => {
              console.log(res.data);
              if (res && res.code === 200) {
                localStorage.setItem("token", res.data.token);
                localStorage.setItem('permissionList',JSON.stringify(res.data.permissionList))
                // localStorage.setItem("menus", JSON.stringify(res.data.menus));
                this.$message({
                  message: "登录成功",
                  type: "success"
                });

                // const params = {
                //   userName: res.data.name,
                //   content: `${res.data.name + "登录了平台"}`,
                //   type: 1,
                //   operateTime: this.$moment(new Date()).format(
                //     "yyyy-MM-DD HH:mm:ss"
                //   ),
                //   endTime: this.endTime,
                //   platform: 7,
                //   module: "登录模块",
                //   userId: this.unitName
                // };
                // addlogoperate(params).then(res => {
                //   console.log(res.data);
                //   // this.tableData = res.data.list;
                //   // this.totalpage = res.data.total;
                // });

                currentUser([]).then(res => {
                  console.log(res.data);
                  localStorage.setItem(
                    "username",
                    res.data.user.nickname || "超级管理员"
                  );
                  localStorage.setItem(
                    "roleInfo",JSON.stringify( res.data.roleList[0])
                  );
                  window.location.href = "/record/ask";
                });


                // if (res.data.menus) {
                //   window.location.href = res.data.menus[0].path;
                //   localStorage.setItem("activetab", res.data.menus[0].path);
                // } else {
                //   window.location.href = "/crossing";
                // }
              }
              if (res && res.status === -1) {
                this.$message({
                  message: res.data,
                  type: "error"
                });
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // window.location.href = "/crossing";
    }
  },
  watch: {
    // $route: {
    //   handler: function(route) {
    //     this.redirect = route.query && route.query.redirect;
    //   },
    //   immediate: true
    // }
  }
};
</script>

<style >
.accounttitle {
  font-size: 22px;
  color: #333333;
  border-bottom: 2px solid #0c88de;
  padding-bottom: 10px;
  margin-bottom: 4vh;
  font-weight: bold;
  text-align: left;
  width: 50px;
  /* text-align: center; */
}

.usernameinput {
  margin-bottom: 4vh;
}

.passinput {
  margin-bottom: 3vh;
}

.logoimg {
  width: 50px;
  margin-right: 20px;
}

.submitbtn {
  width: 100%;
  background: #0c88de;
  border: 1px solid #0c88de;
  display: inline-block;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: white;
  border-radius: 5px;
}

.cover {
  width: 100%;
  /* height: 100%; */
  min-height: 98vh;
  background: url("https://zjiva.terabits.cn/var/file/biluback.png") no-repeat
    bottom center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.logo {
  font-size: 45px;
  font-family: "Alibaba-PuHuiTi1f1b5035d81d0b6";
  color: #2a2a2a;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: #0c88de;
}

.loginmain {
  width: 800px;
  height: 440px;
  margin: 0 auto;
  border-radius: 5px;
  margin-top: 40px;
  box-shadow: -2px 5px 20px #e2e7e7;
  background: #fafcff;
}

.loginl {
  width: 55%;
  height: 440px;
  /* background: url("https://mainimg.terabits.cn/yimeiback.png") no-repeat center
    center; */
  background: url("https://zjiva.terabits.cn/var/file/bilubackmain.png")
    no-repeat center center;
  background-size: cover;
  float: left;
}

.loginr {
  width: 45%;
  float: right;
  padding: 40px;
  box-sizing: border-box;
}

.bombtn {
  text-align: center;
  margin-top: 40px;
  color: #666666;
  font-size: 14px;
}

.bombtns {
  margin-top: 10px;
  color: #666666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
}

#signbody .el-form-item__error {
  top: 50% !important;
}

@media screen and (max-height: 650px) {
  #signbody .logo {
    font-size: 30px;
  }

  #signbody .loginmain {
    height: 300px;
    width: 600px;
    margin-top: 30px;
  }

  #signbody .signlogo {
    width: 50px;
  }

  #signbody .logintitle {
    margin-top: 10px;
  }

  #signbody .loginl {
    height: 300px;
    background-size: 100%;
  }

  #signbody .loginr {
    padding: 20px;
  }

  #signbody .SignIn-Input {
    margin-bottom: 20px;
    margin-top: 30px;
  }

  #signbody .SignIn-Inputs {
    margin-bottom: 20px;
  }
}
</style>